// extracted by mini-css-extract-plugin
export default {"PriceCalendar":"_6lyqA","params":"F8LF7","departureCity":"iHFpE","departureCity-dropdown":"kC07Y","nightsBlock":"_0r7Tj","nights":"VZefC","skeleton-progress":"g5zWz"};